import React from 'react';
import ReactDOMServer from 'react-dom/server';

import LightningIcon from 'app/components/shared/icons/lightning-icon';

import { IDataTypeData } from '../../../PublicationContent';
import './styled';
import { DataTypeToolIconContainer, DataTypeToolPillText, DataTypeToolPillWrapper } from './styled';

export const dataTypeToolContentModifier = (
  node: HTMLDivElement,
  push: (location: any, state?: any) => void,
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>
) => {
  node.querySelectorAll('[data-type="tools"], [data-type="tool"]').forEach((tool) => {
    const slug = tool.getAttribute('data-slug');
    const name = tool.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeToolPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDataTypeData({
        slug,
        type: 'tools',
      });
      push(`/tools/${slug}`);
    });

    tool.replaceWith(template.firstChild);
  });
};

interface DataTypeToolPillProps {
  name: string;
}

export const DataTypeToolPill = ({ name }: DataTypeToolPillProps) => {
  return (
    <DataTypeToolPillWrapper>
      <DataTypeToolIconContainer>
        <LightningIcon width={16} height={16} fill={'var(--color-primary)'} />
      </DataTypeToolIconContainer>
      <DataTypeToolPillText>{name}</DataTypeToolPillText>
    </DataTypeToolPillWrapper>
  );
};
